import React from 'react'

const Manual_creacion_de_boton_de_pago_yappy = () => {
  return (
    <>
       <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
       <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Creación de Botón de Pago Yappy
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía ofrece instrucciones detalladas para crear un botón de pago Yappy en
          InvuPOS, ayudando a las empresas a optimizar sus pagos. Permite configurar el
          sistema de manera sencilla, asegurando transacciones eficientes y una mejor
          experiencia para el cliente.
        </p>
        <iframe
          src="https://scribehow.com/embed/InvuPOS__Creacion_de_Boton_de_Pago__lWolPhuPSqK2QKIos47Mkw?as=scrollable"
           className="scribe-iframe-yappy-2"
          width="100%"
          height="4600"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
      </div>
      </div>
    </>
  )
}

export default Manual_creacion_de_boton_de_pago_yappy